<template>
    <div class="form-page">
        <my-form v-model="form" @submit="submitHandler" table>
            <my-form-item-group title="资格审查问题">
                <el-form-item label="标段名称" prop="bdname" class="table-full-row">
                    {{form.bdname||'-'}}
                </el-form-item>
                <el-form-item label="提交单位名称" prop="tjdwname" class="table-full-row" :rules="newRule('提交单位名称', 'required','string')">
                    <!-- <el-select v-model="form.tjdwname" placeholder="请选择" @change="selectTjdw($event)">
                        <el-option
                            v-for="item in tjdwoptions"
                            :key="item.tjdwcode"
                            :label="item.tjdwname"
                            :value="JSON.stringify({'tjdwname':item.tjdwname,'tjdwcode':item.tjdwcode})">
                        </el-option>
                    </el-select> -->
                    <my-select
                        v-model="form.tjdwcode"
                        :data="tjdwoptions"
                        :props="{label:'tjdwname',value:'tjdwcode'}"
                        2way="tjdwname"
                        :tjdwname.sync="form.tjdwname"
                    ></my-select>
                </el-form-item>
                <el-form-item label="问题标题" prop="yqcqwttitle" class="table-full-row" :rules="newRule('问题标题', 'required')">
                     <el-input v-model="form.yqcqwttitle"  ></el-input>
                </el-form-item>
                <el-form-item label="最晚回复时间" prop="minutes" class="table-full-row" :rules="newRule('最晚回复时间', 'required')">
                    <el-input-number
                        v-model='form.minutes'
                        controls-position="right"
                        :min="1"  
                        @change="changeHfsj"                 
                    ></el-input-number>
                    分钟内，<span style="color:#f95e5e">{{form.zwhfsj}}</span> 截止回复
                </el-form-item>
                <!-- <el-form-item label="最晚回复时间" prop="zwhfsj" class="table-full-row" :rules="newRule('最晚回复时间', 'required')">
                    <el-date-picker v-model="form.zwhfsj" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间" :picker-options="expireTimeOption" @change="xianzhi()"></el-date-picker>
                </el-form-item>
                <div class="tip" v-if="this.form.zwhfsj!==null">
                   最晚回复时间不能小于当前时间,请重新输入 
                </div> -->
                <el-form-item label="内容文本" prop="yqcqwt" class="table-full-row" :rules="newRule('内容文本', 'required')">
                   <ueditor v-model="form.yqcqwt"> </ueditor>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload :file-guid="form.fileguid|| ''"></my-upload>
                </el-form-item> 
            </my-form-item-group>
          <template slot="btn" class="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-check" type="primary" @click="fSave('0',scope.submitHandler)">
                   提交
                </el-button>
            </template> 
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
export default {
    mixins: [FORM_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    data() {
        return{
            tableData:[],
            dialogVisible:false,
            form:{
                yqcqwttitle:'',
                fileguid:'',
                bdname:'',
                xianzhi:'',
                minutes:'30'
               
            },
            data:{
                type: Object,
                default: () => ({})
            },
            tjdwoptions:[],
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            },
            // rules: {
            //     pass: [
            //         { validator: validatePass, trigger: 'blur' }
            //     ],
                
            // }
 
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        timestampToTime(timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
            var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
            var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
            var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
            
            var strDate = Y+M+D+h+m+s;
            return strDate;
            
        },
        selectTjdw(event) {
            event = JSON.parse(event);
            this.form.tjdwcode = event.tjdwcode; 
            this.form.tjdwname = event.tjdwname; 
        },
        changeHfsj() {
            console.log(this.form.minutes)
            var date1 = +new Date(); // +new Date()  返回的就是总的毫秒数
            var date2 = date1+this.form.minutes*60*1000
            this.form.zwhfsj=this.timestampToTime(date2)

            console.log(date1);
            console.log(date2)

        },
        // 提交
        fSave:function(id,cb){           
            this.form.shbj=id;
            cb()

        },
        submitHandler:function(){
            var that=this
            if(this.form.xianzhi==true) {
                return 
            }
            this.form.bdid=this.getQuery('bdcode')
            this.form.bdcode=this.getQuery('bdcode')
            that.$post(`${this.getGetters('bidUrl')}/pingbiao/zgscCqwt/add.json`,
            this.form, (data, res) => {
                ShowMsg(res.msg,'success');
                this.cancleHandler();
            });
        },
        xianzhi() { 
           this.form.xianzhi=true
           if(new Date(new Date()).getTime()-new Date(this.form.zwhfsj).getTime()>0) {
              
                $(".tip").css("display","block");
                $(".el-date-editor .el-input__inner").css("border-color","#F56C6C");
           }
          
        //    else if(this.form.zwhfsj==null){
        //          $(".tip").css("display","none");
        //    }
           else {
                  $(".tip").css("display","none");
                   $(".el-date-editor .el-input__inner").css("border-color","#DCDFE6");
                    this.form.xianzhi=false
           }
        }
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/pingbiao/zgscCqwt/dbdlist.json`, 
        {
           bdcode:this.getQuery('bdcode'),
        }
        ,data => {
            this.form=data.model
            this.form.fileguid=data.fileguid
            this.form.bdname=data.bdmodel.bdname
            this.$set(this.form,"minutes",30)
            var date1 = +new Date(); // +new Date()  返回的就是总的毫秒数
            var date2 = date1+30*60*1000
            this.form.zwhfsj=this.timestampToTime(date2)
           
        });
        this.$post(`${this.getGetters('bidUrl')}/pingbiao/zgscCqwt/getdwlistrest.json`,{
           id:this.getQuery('bdcode'),
        }, (data) => {
            this.tjdwoptions=data.listdata
        });
    },
    mounted() {
    } 

                                            
}
</script>

<style  lang="scss">
.v-modal {
    z-index: 1!important;
    width: 100;
}
.tip {
       color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    display: none;
    top: 160px;
    left: 125px;
    //     top: auto;
    // bottom: 0;
    // left: 5px;
}
.el-table__fixed {
    z-index: 1;
}
</style>
